import React, { useContext } from "react";
import "./About.css";
import SoftwareSkill from "../softwareSkills/SoftwareSkill";
import { skillsSection } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faCoffee } from '@fortawesome/free-solid-svg-icons'

export default function About() {
  const { isDark } = useContext(StyleContext);
  if (!skillsSection.display) {
    return null;
  }
  return (
    <div style={{marginTop:'0px'}} className={isDark ? "dark-mode main" : "main"} id="about">
      <div className="skills-main-div">
       
        <Fade left duration={1000}>
          <div className="skills-image-div border-round">
            <img
              alt="ShakilWorking"
              width="450px"
              src={require("../../img/About.png")}
            ></img>
          </div>
        </Fade>
        <Fade right duration={1000}>
          <div className="skills-text-div pt-5">
            <h1
              className={isDark ? "dark-mode skills-heading" : "skills-heading"}
            >
              About Me
            </h1>
            <h5
              className={
                isDark
                  ? "dark-mode subTitle skills-text-subtitle"
                  : "subTitle skills-text-subtitle"
              }
            >
              I am Shakil Ahmed Front End Developer & I am also working as a MERN developer.
            </h5>
            <p
            className={
              isDark
                ? "dark-mode subTitle skills-text"
                : "subTitle skills-text"
            }
            >
            I am always ready to learn new things to build my career in the challenging and dynamic profession as well as to become a specialist in technical with committed & dedicated people. To achieve my objective I am fully prepared to show my honesty, hard work, physical and mental fitness.
            
            </p>
            <br/>
            <div className={isDark
              ? "dark-mode subTitle skills-text"
              : "subTitle skills-text"
            }>
              <h5><FontAwesomeIcon style={{color:"#166AB8"}} icon={faCircle} /> Specialites: <span>HTML, CSS, SCSS, JavaScript, ES6, React, Bootstrap, Material Design,Firebase.</span></h5>
              <h5><FontAwesomeIcon style={{color:"#166AB8"}} icon={faCircle} /> Also Know: Redux, Node, Express, Webpack, WordPress, etc.</h5>
              <h5><FontAwesomeIcon style={{color:"#166AB8"}} icon={faCircle} /> Familiar: Typescript, React native, Chrome extension, Android Studio, PHP, Laravel, MySQL, Algorithm, OOP,etc.</h5>
              <h5><FontAwesomeIcon style={{color:"#166AB8"}} icon={faCircle} /> Design: Adobe, Canva, etc.</h5>
              <h5><FontAwesomeIcon style={{color:"#166AB8"}} icon={faCircle} /> Tools: Git, Chrome Dev Tool, VS Code, Jira, etc.</h5>
            </div>
            <div>
              {skillsSection.skills.map((skills, i) => {
                return (
                  <p
                    key={i}
                    className={
                      isDark
                        ? "dark-mode subTitle skills-text"
                        : "subTitle skills-text"
                    }
                  >
                    
                  </p>
                );
              })}
            </div>
          </div>
        </Fade>
      </div>
    </div>
  );
}
